import React from "react";

const PrivacyPolicy = () => {
  return (
    <div className="container m-auto py-4 h-full">
      <div className="flex flex-col justify-between mt-10 mx-60">
        <div>
          <h2 className="text-2xl text-teal-800 font-bold border-b-2">
            {" "}
            Privacy Policy
          </h2>
        </div>
        <div>
          <h2 className="text-lg mt-5 "> Overview</h2>
          <p>
            {" "}
            AboutTheFit.com is strongly committed to respecting the privacy of
            all persons using our websites and the protection of any personally
            identifiable information which we may collect on our Websites and or
            use as part of our data collection process and or which you may
            choose to share with us in our stores or via telephone, email or
            otherwise (“the Other Channels”). Such personal information will be
            collected and or used in accordance with the terms and conditions of
            this Privacy Policy, which is part of and incorporated into the
            Terms of Use of the Web Site.{" "}
          </p>
        </div>

        <div>
          <h2 className="text-lg mt-5 "> Changes to Privacy Policy</h2>
          <p>
            Since we are constantly making changes and upgrades to our systems
            and services in order to better serve you, we anticipate updating
            this Privacy Policy from time-to-time. Therefore, we reserve the
            right to revise or alter the content of this Privacy Policy in any
            manner and at any time, without notice. Your subsequent and/ or
            continued use of the WebSites and the other Channels following a
            posting of changes to the Privacy Policy will constitute your
            acceptance of such changes.{" "}
          </p>
        </div>
        <div>
          <h2 className="text-lg mt-5 "> Third Party Web Sites</h2>
          <p>
            You may be able to access certain third-party websites through links
            on our Web Sites/Apps. We are not, however, responsible for any
            other websites, their respective privacy policies or other content
            nor how they treat information about their visitors or users. We
            strongly advise you to check their privacy policies to find out how
            they are treating your Personal Information.{" "}
          </p>
        </div>

        <div>
          <h2 className="text-lg mt-5 "> No Warranty</h2>
          <p>
            YOU UNDERSTAND THAT We DOES NOT PROVIDE ANY WARRANTY, GUARANTEE OR
            REPRESENTATION OF ANY KIND CONCERNING OUR ABILITY TO CONTROL,
            COLLECT, CORRECT, ACCESS, PROCESS, USE, STORE, PROTECT OR TRANSFER
            ANY PERSONAL INFORMATION OR CONCERNING THE EXISTENCE OR
            EFFECTIVENESS OF ANY SECURITY MEASURES UNDERTAKEN BY US. YOU AGREE
            THAT ALSHAYA GROUP WILL NOT BE LIABLE FOR ANY CLAIMS, LOSSES, OR
            DAMAGES OF ANY KIND WHATSOEVER WHICH MAY RESULT FROM THE ACCESS,
            DISCLOSURE, USE OR MODIFICATION BY ANY PARTY NOT AUTHORISED OR
            AUTHORISED BY US, OR THE INTRODUCTION OF VIRUSES, WORMS, OR OTHER
            HARMFUL ELEMENTS INTO THE SYSTEM AND THEIR POSSIBLE EFFECTS ON YOUR
            PERSONAL INFORMATION.{" "}
          </p>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
